import { render, staticRenderFns } from "./drawer-info.vue?vue&type=template&id=9bba7cf4&scoped=true"
import script from "./drawer-info.vue?vue&type=script&lang=js"
export * from "./drawer-info.vue?vue&type=script&lang=js"
import style0 from "./drawer-info.vue?vue&type=style&index=0&id=9bba7cf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bba7cf4",
  null
  
)

export default component.exports